export enum ParamsSortBy {
  one = 'Newest',
  two = 'Alphabetically',
  three = 'Cheapest',
}
